import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";
import { AuthShell } from "@/pages/authShared";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true); setLoading(false);
  };
  return (
    <AuthShell title="Reset password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <div className="text-center py-4">
          <CheckCircle2 className="w-12 h-12 text-teal mx-auto mb-3" />
          <p className="text-slate-600 text-sm">If that email is registered, a reset link has been sent. Check your inbox.</p>
          <Button asChild variant="outline" className="mt-6"><Link to="/login" data-testid="back-to-login">Back to sign in</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-xs">Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" /></div>
          <Button type="submit" className="w-full bg-teal hover:bg-teal-dark text-white" disabled={loading} data-testid="forgot-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </Button>
          <Link to="/login" className="block text-center text-sm text-teal" data-testid="back-to-login">Back to sign in</Link>
        </form>
      )}
    </AuthShell>
  );
}
